import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { carCaseActions } from '../../../application/actions/carCase';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);

// GETBYID
export function* getByIdFetch(e) {
    yield put(carCaseActions.conexionGetById({connection:true}));
    try {
        const  params  = e.payload;
        const url = `car/case/${params.id}`
        const response = yield call(
            apiRequest.get,
            url,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(carCaseActions.getById({data}));
    } catch (err) {
        yield put(carCaseActions.errorGetById({error:true, message:err.message}));
    } finally {
        yield put(carCaseActions.conexionGetById({connection:false}));
    }
}

// CREATE
export function* createFetch(e) {
    yield put(carCaseActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `car/case/`
        const response = yield call(
            apiRequest.post,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(carCaseActions.create({result}));
    } catch (err) {
        yield put(carCaseActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(carCaseActions.conexionCreate({connection:false}));
    }
}
// UPDATE
export function* updateFetch(e) {
    yield put(carCaseActions.conexionUpdate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `car/case/${params.id}`
        const response = yield call(
            apiRequest.put,
            url,
            params.data
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(carCaseActions.update({result}));
    } catch (err) {
        yield put(carCaseActions.errorUpdate({error:true, message:err.message}));
    } finally {
        yield put(carCaseActions.conexionUpdate({connection:false}));
    }
}

// UPDATE STATUS
export function* updateStatusFetch(e) {
    yield put(carCaseActions.conexionUpdateStatus({connection:true}));
    try {
        const  params  = e.payload;
        const url = `car/case/status/${params.caseId}/${params.stateId}`
        const response = yield call(
            apiRequest.put,
            url,
            params
        );

        // Extraigo todos los datos
        const { result } = response;
        yield put(carCaseActions.updateStatus({result}));
    } catch (err) {
        yield put(carCaseActions.errorUpdateStatus({error:true, message:err.message}));
    } finally {
        yield put(carCaseActions.conexionUpdateStatus({connection:false}));
    }
}

export function* watchFetchCarCase() {
    yield takeLatest(carCaseActionsSaga.getById.type,  getByIdFetch);
    yield takeLatest(carCaseActionsSaga.create.type,  createFetch);
    yield takeLatest(carCaseActionsSaga.update.type,  updateFetch);
    yield takeLatest(carCaseActionsSaga.updateStatus.type,  updateStatusFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchCarCase);
}

const getById = createAction('carCaseSaga/getById');
const create = createAction('carCaseSaga/create');
const update = createAction('carCaseSaga/update');
const updateStatus = createAction('carCaseSaga/updateStatus');

export const carCaseActionsSaga = {
    getById,
    create,
    update,
    updateStatus
};
